<template>
  <div class="new-list-mobile">
    <div class="hot-travel">
      <div class="hot-travel-circle"></div>
      <span class="hot-travel-text">最新游记</span>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已经到底了"
      @load="onLoad"
      :immediate-check="false"
    >
      <TravelCard
        class="hot-travel-card"
        v-for="(travel,index) in newTravelList"
        :key="`${travel.id}`"
        :item="travel"
        :offset="offset"
      >
        <div class="card-divider" v-if="index !== newTravelList.length - 1"></div>
      </TravelCard>
    </van-list>
  </div>
</template>
<script>
//使用vant的懒加载
import { mapState, mapActions } from "vuex";
import { List } from "vant";
import TravelCard from "@/mobileCom/TravelCard";
export default {
  name: "new-list",
  components: {
    [List.name]: List,
    TravelCard
  },
  data() {
    return {
      offset: 0,
      page: 1,
      loading: false,
      finished: false,
      newTravelList: []
    };
  },
  computed: {
    ...mapState("HomeDataStore", ["newTravels"])
  },
  watch: {
    newTravels(value) {
      this.loading = false;
      this.newTravelList.push(...value);
      if (this.newTravelList.length >= 50) {
        this.finished = true;
      }
    }
  },
  created() {
    //查询最新游记(5篇)
    this.getnewTravels({
      page: 1,
      rows: 6,
      dataType: 14,
      word: "",
      flag: 1
    });
  },
  methods: {
    onLoad() {
      this.page += 1;
      this.getnewTravels({
        page: this.page,
        rows: 6,
        dataType: 14,
        word: "",
        flag: 1
      });
    },
    processImgs(imgs) {
      if (imgs) {
        return imgs.split(";")[0];
      }
      return imgs;
    },
    ...mapActions("HomeDataStore", ["getnewTravels"])
  }
};
</script>
<style lang="less">
@import "~@/mobile_css/list_related.less";
.new-list-mobile {
  padding-left: 10px;
  padding-right: 16px;
  .hot-travel {
    .hot_travel_common();
  }
  .hot-travel-card {
    margin-bottom: 12px;
  }
}
</style>
